import { cn } from "@/lib/utils/cn";
import { ReactNode } from "react";

function getFontSize(letterCount: number, breakAt: number[]) {
  switch (true) {
    case breakAt[2] && letterCount >= breakAt[2]: {
      return "text-md";
    }
    case breakAt[1] && letterCount >= breakAt[1]: {
      return "text-lg";
    }
    case breakAt[0] && letterCount >= breakAt[0]: {
      return "text-xl";
    }
    default: {
      return "text-2xl";
    }
  }
}

// define all possible class sizes so that tailwind can compile them
const fontSizes = {
  "text-md": "text-md",
  "text-lg": "text-lg",
  "text-xl": "text-xl",
  "text-2xl": "text-2xl",

  "sm:text-md": "sm:text-md",
  "sm:text-lg": "sm:text-lg",
  "sm:text-xl": "sm:text-xl",
  "sm:text-2xl": "sm:text-2xl",

  "md:text-md": "md:text-md",
  "md:text-lg": "md:text-lg",
  "md:text-xl": "md:text-xl",
  "md:text-2xl": "md:text-2xl",

  "lg:text-md": "lg:text-md",
  "lg:text-lg": "lg:text-lg",
  "lg:text-xl": "lg:text-xl",
  "lg:text-2xl": "lg:text-2xl",

  "xl:text-md": "xl:text-md",
  "xl:text-lg": "xl:text-lg",
  "xl:text-xl": "xl:text-xl",
  "xl:text-2xl": "xl:text-2xl",
};

export function DynamicTitle({
  title,
  tag: Tag = "h1",
  children,
  className,
}: {
  title: string;
  tag?: "h1" | "span";
  children?: ReactNode;
  className?: string;
}) {
  return (
    <Tag
      className={cn(
        fontSizes[getFontSize(title.length, [14, 18, 50])],
        fontSizes[`sm:${getFontSize(title.length, [22, 27, 65])}`],
        fontSizes[`md:${getFontSize(title.length, [30, 40, 55])}`],
        fontSizes[`lg:${getFontSize(title.length, [40, 55])}`],
        fontSizes[`xl:${getFontSize(title.length, [50, 65])}`],
        "flex-1 text-ellipsis text-nowrap overflow-hidden block",
        className
      )}
    >
      {title}
      {children}
    </Tag>
  );
}
